import { COLOR } from 'constants/colors';
import React from 'react';

export const UpAGreenArrowIcon: React.FC = () => {
    return <svg width="10" height="14" viewBox="0 0 10 14" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g>
            <path d="M1.28532 7.82561L3.88718 7.85374L3.88658 13.7753C3.88658 13.9292 4.04043 13.9892 4.11735 14H5.78982C6.00811 14 6.07535 13.8744 6.08169 13.8117V7.83972C6.95067 7.8291 8.72513 7.80425 8.87111 7.78978C9.05359 7.7717 9.4441 7.78616 9.76526 7.40278C10.1594 6.96297 9.96955 6.44772 9.82535 6.24507C8.48151 4.35823 5.7729 0.557289 5.68921 0.44825C5.5846 0.311951 5.35979 0 4.87678 0C4.49037 0 4.19639 0.298833 4.0977 0.44825L0.268783 5.94684C0.214173 6.02282 0.0912728 6.22168 0.0365497 6.40924C-0.0518056 6.72276 0.0336995 6.94308 0.147704 7.18317C0.323275 7.63962 0.979269 7.80165 1.28532 7.82561Z" fill="#00A465" />
        </g>
    </svg>

}
